import React from 'react';
import { withStyles} from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Moment from 'react-moment';
import IconButton from '@material-ui/core/IconButton';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import LocalLibraryOutlinedIcon from '@material-ui/icons/LocalLibraryOutlined';
import BookOutlinedIcon from '@material-ui/icons/BookOutlined';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SwapVertIcon from '@material-ui/icons/SwapVert';

const styles = theme => ({
  root: {
    display: 'block',
    width: '100%',
    border: '1px solid #f5f5f5',
    borderRadius: 5,
    overflowX: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    '-ms-overflow-style': '-ms-autohiding-scrollbar',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    '& thead tr th': {
      padding: 10,
      textAlign: 'center',
      fontSize: 12,
      border: '1px solid #f5f5f5',
      cursor: 'pointer',
    },
    '& tbody tr td': {
      padding: 10,
      border: '1px solid #f5f5f5',
    },
    '& tbody tr:nth-of-type(odd) td': {
      backgroundColor: '#fafafa',
    },
  },
  tableHeadingText: {
    lineHeight: 2,
    fontSize: 14,
    '& b': {
      verticalAlign: 'super',
    },
  },
  textMute: {
    color: '#999999',
  },
});

class ReportCardsGroupTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: null,
      sortDirection: null,
    };

    this.columns = [
      {
        key: 'detail',
        headingWidth: 45,
        content: (entry) => {
          return (
            <React.Fragment>
              <IconButton
                onClick={this.props.onEntryClick.bind(this, entry)}
                className="open-report-cards-details-button"
              >
                <OpenInNewIcon />
              </IconButton>
            </React.Fragment>
          );
        },
      },
      {
        key: 'date',
        headingWidth: 180,
        headingIcon: <LocalLibraryOutlinedIcon fontSize="small" />,
        headingText: props.t('Date'),
        content: (entry) => {
          return (
            <React.Fragment>
              <span><Moment format={dateFormat}>{entry.start_date}</Moment> - </span>
              <Moment format={dateFormat}>{entry.end_date}</Moment>
            </React.Fragment>
          );
        },
      },
      {
        key: 'reason',
        headingWidth: 120,
        headingIcon: <AccountCircleOutlinedIcon fontSize="small" />,
        headingText: props.t('Report type'),
        content: (entry) => {
          return (
            <React.Fragment>
              {entry.reason}
            </React.Fragment>
          );
        },
      },
      {
        key: 'description',
        headingIcon: <BookOutlinedIcon fontSize="small" />,
        headingText: props.t('Description'),
        content: (entry) => {
          return (
            <React.Fragment>
              {entry.description}
            </React.Fragment>
          );
        },
      },
    ];

    this.onTableHeadingClick = this.onTableHeadingClick.bind(this);
    this.getFinalEntries = this.getFinalEntries.bind(this);
  }

  onTableHeadingClick(column) {
    const {
      sort,
      sortDirection,
    } = this.state;

    if (column.key === 'details') {
      return;
    }

    let newSort = column.key;
    let newSortDirection = sortDirection;

    if (!newSortDirection) {
      newSortDirection = 'asc';
    }

    if (newSort === sort) {
      newSortDirection = newSortDirection === 'asc'
        ? 'desc'
        : 'asc';
    }

    this.setState({
      sort: newSort,
      sortDirection: newSortDirection,
    });
  }

  getFinalEntries(entries) {
    const {
      sort,
      sortDirection,
    } = this.state;

    let finalEntries = [ ...entries ];

    finalEntries.sort((a, b) => {
      if (
        typeof a[sort] !== 'undefined' &&
        typeof b[sort] !== 'undefined'
      ) {
        return a[sort].localeCompare(b[sort]);
      }

      return 0;
    });

    if (sortDirection === 'desc') {
      finalEntries = finalEntries.reverse();
    }

    return finalEntries;
  }

  render() {
    const {
      classes,
      entries,
    } = this.props;
    const {
      sort,
      sortDirection,
    } = this.state;

    const finalEntries = this.getFinalEntries(entries);

    return (
      <div className={`report-cards-group-table ${classes.root}`}>
        <table className={classes.table}>
          <thead>
            <tr>
              {this.columns.map((column) => {
                let columnProps = {};
                if (column.headingWidth) {
                  columnProps.width = column.headingWidth;
                }

                return (
                  <th
                    { ...columnProps }
                    key={column.key}
                    onClick={this.onTableHeadingClick.bind(this, column)}
                  >
                    <div className={classes.tableHeadingText}>
                      <b>{column.headingText}</b>
                      {(column.key !== sort || !sortDirection) && column.key !== 'detail' && (
                        <span>
                          <SwapVertIcon className={classes.textMute} fontSize="small" />
                        </span>
                      )}
                      {column.key === sort && sortDirection && column.key !== 'detail' && (
                        <span>
                          {sortDirection === 'asc' && (
                            <ArrowUpwardIcon fontSize="small" />
                          )}
                          {sortDirection === 'desc' && (
                            <ArrowDownwardIcon fontSize="small" />
                          )}
                        </span>
                      )}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {finalEntries.map((entry) => {
              return (
                <tr key={entry.id}>
                  {this.columns.map((column) => {
                    return (
                      <td key={column.key}>
                        {column.content.bind(this, entry)()}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(ReportCardsGroupTable));
